// This file provides correct asset paths for Parcel bundling

// Import all assets so Parcel can process them
import letterA from '../assets/images/final/A.png';
import letterB from '../assets/images/final/B.png';
import letterC from '../assets/images/final/C.png';
import letterD from '../assets/images/final/D.png';
import letterE from '../assets/images/final/E.png';
import letterF from '../assets/images/final/F.png';
import letterG from '../assets/images/final/G.png';
import letterH from '../assets/images/final/H.png';
import letterI from '../assets/images/final/I.png';
import letterJ from '../assets/images/final/J.png';
import letterK from '../assets/images/final/K.png';
import letterL from '../assets/images/final/L.png';
import letterM from '../assets/images/final/M.png';
import letterN from '../assets/images/final/N.png';
import letterO from '../assets/images/final/O.png';
import letterP from '../assets/images/final/P.png';
import letterQ from '../assets/images/final/Q.png';
import letterR from '../assets/images/final/R.png';
import letterS from '../assets/images/final/S.png';
import letterT from '../assets/images/final/T.png';
import letterU from '../assets/images/final/U.png';
import letterV from '../assets/images/final/V.png';
import letterW from '../assets/images/final/W.png';
import letterX from '../assets/images/final/X.png';
import letterY from '../assets/images/final/Y.png';
import letterZ from '../assets/images/final/Z.png';
import closeIcon from '../assets/images/close.svg';
import badgeIcon from '../assets/images/badge.svg';
import introVideo from '../assets/videos/intro.mp4';
import nohintImage from '../assets/images/nohint.png';

// Sounds
import periodSoundFile from '../assets/sounds/period.mp3';
import dashSoundFile from '../assets/sounds/dash.mp3';
import dotSoundFile from '../assets/sounds/dot.mp3';
import correctSoundFile from '../assets/sounds/correct.mp3';
import wrongSoundFile from '../assets/sounds/wrong.mp3';

// Letter sounds (assets/sounds/)
import letterASoundFile from '../assets/sounds/a.mp3';
import letterBSoundFile from '../assets/sounds/b.mp3';
import letterCSoundFile from '../assets/sounds/c.mp3';
import letterDSoundFile from '../assets/sounds/d.mp3';
import letterESoundFile from '../assets/sounds/e.mp3';
import letterFSoundFile from '../assets/sounds/f.mp3';
import letterGSoundFile from '../assets/sounds/g.mp3';
import letterHSoundFile from '../assets/sounds/h.mp3';
import letterISoundFile from '../assets/sounds/i.mp3';
import letterJSoundFile from '../assets/sounds/j.mp3';
import letterKSoundFile from '../assets/sounds/k.mp3';
import letterLSoundFile from '../assets/sounds/l.mp3';
import letterMSoundFile from '../assets/sounds/m.mp3';
import letterNSoundFile from '../assets/sounds/n.mp3';
import letterOSoundFile from '../assets/sounds/o.mp3';
import letterPSoundFile from '../assets/sounds/p.mp3';
import letterQSoundFile from '../assets/sounds/q.mp3';
import letterRSoundFile from '../assets/sounds/r.mp3';
import letterSSoundFile from '../assets/sounds/s.mp3';
import letterTSoundFile from '../assets/sounds/t.mp3';
import letterUSoundFile from '../assets/sounds/u.mp3';
import letterVSoundFile from '../assets/sounds/v.mp3';
import letterWSoundFile from '../assets/sounds/w.mp3';
import letterXSoundFile from '../assets/sounds/x.mp3';
import letterYSoundFile from '../assets/sounds/y.mp3';
import letterZSoundFile from '../assets/sounds/z.mp3';

// Soundalike sounds (assets/sounds/soundalikes-mw/)
import soundalikeMwASoundFile from '../assets/sounds/soundalikes-mw/a.mp3';
import soundalikeMwBSoundFile from '../assets/sounds/soundalikes-mw/b.mp3';
import soundalikeMwCSoundFile from '../assets/sounds/soundalikes-mw/c.mp3';
import soundalikeMwDSoundFile from '../assets/sounds/soundalikes-mw/d.mp3';
import soundalikeMwESoundFile from '../assets/sounds/soundalikes-mw/e.mp3';
import soundalikeMwFSoundFile from '../assets/sounds/soundalikes-mw/f.mp3';
import soundalikeMwGSoundFile from '../assets/sounds/soundalikes-mw/g.mp3';
import soundalikeMwHSoundFile from '../assets/sounds/soundalikes-mw/h.mp3';
import soundalikeMwISoundFile from '../assets/sounds/soundalikes-mw/i.mp3';
import soundalikeMwJSoundFile from '../assets/sounds/soundalikes-mw/j.mp3';
import soundalikeMwKSoundFile from '../assets/sounds/soundalikes-mw/k.mp3';
import soundalikeMwLSoundFile from '../assets/sounds/soundalikes-mw/l.mp3';
import soundalikeMwMSoundFile from '../assets/sounds/soundalikes-mw/m.mp3';
import soundalikeMwNSoundFile from '../assets/sounds/soundalikes-mw/n.mp3';
import soundalikeMwOSoundFile from '../assets/sounds/soundalikes-mw/o.mp3';
import soundalikeMwPSoundFile from '../assets/sounds/soundalikes-mw/p.mp3';
import soundalikeMwQSoundFile from '../assets/sounds/soundalikes-mw/q.mp3';
import soundalikeMwRSoundFile from '../assets/sounds/soundalikes-mw/r.mp3';
import soundalikeMwSSoundFile from '../assets/sounds/soundalikes-mw/s.mp3';
import soundalikeMwTSoundFile from '../assets/sounds/soundalikes-mw/t.mp3';
import soundalikeMwUSoundFile from '../assets/sounds/soundalikes-mw/u.mp3';
import soundalikeMwVSoundFile from '../assets/sounds/soundalikes-mw/v.mp3';
import soundalikeMwWSoundFile from '../assets/sounds/soundalikes-mw/w.mp3';
import soundalikeMwXSoundFile from '../assets/sounds/soundalikes-mw/x.mp3';
import soundalikeMwYSoundFile from '../assets/sounds/soundalikes-mw/y.mp3';
import soundalikeMwZSoundFile from '../assets/sounds/soundalikes-mw/z.mp3';


// Create a mapping of asset keys to their resolved paths
const assetPaths = {
  a: letterA,
  b: letterB,
  c: letterC,
  d: letterD,
  e: letterE,
  f: letterF,
  g: letterG,
  h: letterH,
  i: letterI,
  j: letterJ,
  k: letterK,
  l: letterL,
  m: letterM,
  n: letterN,
  o: letterO,
  p: letterP,
  q: letterQ,
  r: letterR,
  s: letterS,
  t: letterT,
  u: letterU,
  v: letterV,
  w: letterW,
  x: letterX,
  y: letterY,
  z: letterZ,
  close: closeIcon,
  badge: badgeIcon,
  intro: introVideo,
  nohint: nohintImage,

  periodSound: periodSoundFile,
  dashSound: dashSoundFile,
  dotSound: dotSoundFile,
  correctSound: correctSoundFile,
  wrongSound: wrongSoundFile,

  letter_a_sound: letterASoundFile,
  letter_b_sound: letterBSoundFile,
  letter_c_sound: letterCSoundFile,
  letter_d_sound: letterDSoundFile,
  letter_e_sound: letterESoundFile,
  letter_f_sound: letterFSoundFile,
  letter_g_sound: letterGSoundFile,
  letter_h_sound: letterHSoundFile,
  letter_i_sound: letterISoundFile,
  letter_j_sound: letterJSoundFile,
  letter_k_sound: letterKSoundFile,
  letter_l_sound: letterLSoundFile,
  letter_m_sound: letterMSoundFile,
  letter_n_sound: letterNSoundFile,
  letter_o_sound: letterOSoundFile,
  letter_p_sound: letterPSoundFile,
  letter_q_sound: letterQSoundFile,
  letter_r_sound: letterRSoundFile,
  letter_s_sound: letterSSoundFile,
  letter_t_sound: letterTSoundFile,
  letter_u_sound: letterUSoundFile,
  letter_v_sound: letterVSoundFile,
  letter_w_sound: letterWSoundFile,
  letter_x_sound: letterXSoundFile,
  letter_y_sound: letterYSoundFile,
  letter_z_sound: letterZSoundFile,

  soundalike_mw_a_sound: soundalikeMwASoundFile,
  soundalike_mw_b_sound: soundalikeMwBSoundFile,
  soundalike_mw_c_sound: soundalikeMwCSoundFile,
  soundalike_mw_d_sound: soundalikeMwDSoundFile,
  soundalike_mw_e_sound: soundalikeMwESoundFile,
  soundalike_mw_f_sound: soundalikeMwFSoundFile,
  soundalike_mw_g_sound: soundalikeMwGSoundFile,
  soundalike_mw_h_sound: soundalikeMwHSoundFile,
  soundalike_mw_i_sound: soundalikeMwISoundFile,
  soundalike_mw_j_sound: soundalikeMwJSoundFile,
  soundalike_mw_k_sound: soundalikeMwKSoundFile,
  soundalike_mw_l_sound: soundalikeMwLSoundFile,
  soundalike_mw_m_sound: soundalikeMwMSoundFile,
  soundalike_mw_n_sound: soundalikeMwNSoundFile,
  soundalike_mw_o_sound: soundalikeMwOSoundFile,
  soundalike_mw_p_sound: soundalikeMwPSoundFile,
  soundalike_mw_q_sound: soundalikeMwQSoundFile,
  soundalike_mw_r_sound: soundalikeMwRSoundFile,
  soundalike_mw_s_sound: soundalikeMwSSoundFile,
  soundalike_mw_t_sound: soundalikeMwTSoundFile,
  soundalike_mw_u_sound: soundalikeMwUSoundFile,
  soundalike_mw_v_sound: soundalikeMwVSoundFile,
  soundalike_mw_w_sound: soundalikeMwWSoundFile,
  soundalike_mw_x_sound: soundalikeMwXSoundFile,
  soundalike_mw_y_sound: soundalikeMwYSoundFile,
  soundalike_mw_z_sound: soundalikeMwZSoundFile,
};

export default assetPaths;
